import React, { HTMLAttributes } from 'react';

import { trackingLinkByMethod } from './trackingUtils';

type Props = {
  deliveryMethod: string;
  trackingNumber: string;
} & HTMLAttributes<HTMLAnchorElement>;

export default function TrackingLink({
  deliveryMethod,
  trackingNumber,
  ...props
}: Props): JSX.Element | null {
  const trackingLink = trackingLinkByMethod[deliveryMethod];

  if (!trackingLink) {
    return null;
  }

  return (
    <a
      target="_blank"
      rel="noreferrer"
      href={trackingLink.replace('%trackingNumber%', trackingNumber)}
      {...props}
    >
      {trackingNumber}
    </a>
  );
}
